/*
 * Bloco de parcelamento + PIX.
 *
 * Fonte unica do componente. Substitui os 38 blocos custom_code que viviam
 * copiados dentro dos templates JSON em 12 versoes divergentes -- entre elas
 * duas TABELAS DE JUROS diferentes rodando na mesma pagina (o widget do topo
 * dizia "3x sem juros", o de baixo cobrava 1.0923 no 3x).
 *
 * O valor inicial das 12 parcelas vem renderizado do servidor por
 * snippets/parcelamento-pix.liquid. Este arquivo so REESCREVE os valores
 * quando a variante muda. Se o JS falhar, o cliente continua vendo preco
 * correto -- ao contrario do se-parcelamento-pix.js que isto substitui, que
 * deixava o Liquid imprimir o preco cheio nas 12 linhas e dependia do JS
 * para tudo (e cujo script nunca chegou a ser carregado no tema).
 *
 * A aritmetica espelha a de inteiros do Liquid de proposito, para que os dois
 * lados produzam o mesmo centavo. Coberto por tests/parcelamento.test.js.
 */
(function (raiz, fabrica) {
  var api = fabrica();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    raiz.NEParcelamento = api;
    if (typeof document !== 'undefined') api.iniciar();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  var TAXAS = {
    1: 1, 2: 1, 3: 1,
    4: 1.0758, 5: 1.0914, 6: 1.1071,
    7: 1.1231, 8: 1.1392, 9: 1.1553,
    10: 1.1716, 11: 1.1883, 12: 1.2047
  };

  var fmt = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function formatBRL(centavos) {
    return 'R$ ' + fmt.format((Number(centavos) || 0) / 100);
  }

  function parsePrecoCentavos(texto) {
    if (!texto) return 0;

    var limpo = String(texto)
      .replace(/[\s ]/g, '')
      .replace(/[^\d.,-]/g, '');

    if (!limpo) return 0;

    limpo = limpo.replace(/\.(?=\d{3}(?:[.,]|$))/g, '').replace(',', '.');

    var valor = parseFloat(limpo);
    return isNaN(valor) ? 0 : Math.round(valor * 100);
  }

  // espelha `preco | divided_by: n | times: taxa | round` do Liquid
  function centavosParcela(centavos, n) {
    var base = Math.floor(centavos / n);
    return Math.round(base * TAXAS[n]);
  }

  function centavosPix(centavos, percentual) {
    return Math.round(centavos * (1 - percentual / 100));
  }

  function textoParcela(centavos, n) {
    var valor = formatBRL(centavosParcela(centavos, n));
    return n <= 3
      ? '<b>' + n + 'x</b> de ' + valor + ' sem juros'
      : '<b>' + n + 'x</b> de ' + valor + '*';
  }

  function desenhar(raizEl, centavos) {
    if (!centavos || centavos <= 0) return;

    for (var n = 1; n <= 12; n++) {
      var alvo = raizEl.querySelector('[data-ne-parcela="' + n + '"]');
      if (alvo) alvo.innerHTML = textoParcela(centavos, n);
    }

    var elPix = raizEl.querySelector('[data-ne-pix-preco]');
    if (elPix) {
      var pct = Number(raizEl.getAttribute('data-ne-pix-desconto'));
      if (!isFinite(pct)) pct = 5;
      elPix.textContent = formatBRL(centavosPix(centavos, pct));
    }
  }

  /* ---------- DOM ---------- */

  function dono(raizEl) {
    return raizEl.closest('[data-product-info]') ||
      raizEl.closest('.product-single__details') ||
      raizEl.closest('.shopify-section') ||
      document;
  }

  function ligarToggle(raizEl) {
    var gatilho = raizEl.querySelector('[data-ne-toggle]');
    var conteudo = raizEl.querySelector('[data-ne-conteudo]');
    var seta = raizEl.querySelector('[data-ne-seta]');
    if (!gatilho || !conteudo) return;

    gatilho.setAttribute('aria-expanded', 'false');

    gatilho.addEventListener('click', function () {
      var aberto = raizEl.classList.contains('is-open');

      if (aberto) {
        raizEl.classList.remove('is-open');
        gatilho.setAttribute('aria-expanded', 'false');
        conteudo.style.maxHeight = '0px';
        conteudo.style.padding = '0 15px';
        if (seta) seta.classList.remove('open');
        setTimeout(function () { conteudo.style.display = 'none'; }, 300);
      } else {
        raizEl.classList.add('is-open');
        gatilho.setAttribute('aria-expanded', 'true');
        conteudo.style.display = 'block';
        setTimeout(function () {
          conteudo.style.maxHeight = (conteudo.scrollHeight + 20) + 'px';
          conteudo.style.padding = '15px';
        }, 10);
        if (seta) seta.classList.add('open');
      }
    });
  }

  function iniciarBloco(raizEl) {
    if (raizEl.dataset.neParcelamentoPronto === 'true') return;
    raizEl.dataset.neParcelamentoPronto = 'true';

    ligarToggle(raizEl);

    var escopo = dono(raizEl);
    var observado = null;
    var observer = null;

    function daPagina() {
      var elPreco = escopo.querySelector('[data-product-price]');
      if (!elPreco) return;
      desenhar(raizEl, parsePrecoCentavos(elPreco.textContent || elPreco.innerText || ''));
    }

    function religar() {
      var elPreco = escopo.querySelector('[data-product-price]');
      if (!elPreco || elPreco === observado) return;

      if (observer) observer.disconnect();
      observado = elPreco;
      observer = new MutationObserver(daPagina);
      observer.observe(elPreco, { characterData: true, childList: true, subtree: true });
      daPagina();
    }

    religar();

    // caminho preferido: o tema entrega o preco da variante em centavos
    escopo.addEventListener('theme:variant:change', function (e) {
      if (e.detail && e.detail.variant && typeof e.detail.variant.price !== 'undefined') {
        desenhar(raizEl, Number(e.detail.variant.price));
      } else {
        setTimeout(daPagina, 30);
        setTimeout(daPagina, 120);
      }
    });

    // rede de seguranca para temas que so mexem no DOM
    escopo.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-single-option-selector], [data-product-select]')) {
        setTimeout(daPagina, 30);
        setTimeout(daPagina, 120);
      }
    });

    new MutationObserver(religar).observe(escopo === document ? document.body : escopo, {
      childList: true,
      subtree: true
    });
  }

  function iniciar(escopo) {
    var alvos = (escopo || document).querySelectorAll('[data-ne-parcelamento]');
    Array.prototype.forEach.call(alvos, iniciarBloco);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    }
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  }

  return {
    TAXAS: TAXAS,
    formatBRL: formatBRL,
    parsePrecoCentavos: parsePrecoCentavos,
    centavosParcela: centavosParcela,
    centavosPix: centavosPix,
    textoParcela: textoParcela,
    desenhar: desenhar,
    iniciar: iniciar
  };
});
